// extracted by mini-css-extract-plugin
export default {"workersAddBlock":"Workers_workersAddBlock__zi8AI","content":"Workers_content__tphCc","footer":"Workers_footer__NlLHW","customBody":"Workers_customBody__bxtY4"};